import { TurboStripType } from "@core-ui/interfaces/Turbo";
import { IColors, ITypography } from "@swiggy-private/dls-web-common/dist/components/types";

export const getTextVariantAndColor = (
    type: TurboStripType,
): {
    textVariant: keyof ITypography;
    patternTextVariant: keyof ITypography;
    textColor: keyof IColors;
    patternTextColor: keyof IColors;
} => {
    switch (type) {
        case TurboStripType.STATIC_INVERSE:
            return {
                textVariant: "V2.overline.neutral.medium",
                patternTextVariant: "V2.overline.neutral.medium",
                textColor: "text_High_Emphasis",
                patternTextColor: "text_Highest_Emphasis",
            };
        case TurboStripType.DYNAMIC_SPLIT_PAY_INFO:
            return {
                textVariant: "V2.body2.neutral.medium",
                patternTextVariant: "V2.body2.neutral.bold",
                textColor: "text_Button_Secondary",
                patternTextColor: "swiggy_One",
            };
        default:
            return {
                textVariant: "V2.body3.neutral.bold",
                patternTextVariant: "V2.body3.neutral.bold",
                textColor: "text_High_Emphasis",
                patternTextColor: "text_Highest_Emphasis",
            };
    }
};
